module.exports = __webpack_public_path__ + "static/media/project.1a1b83ef.jpg";